import { AbstractControl, FormGroup, ValidatorFn } from "@angular/forms";

export function needsAnyValidator(keys: string[]): ValidatorFn {
  return (ctrl: AbstractControl) => {
    const g = ctrl as FormGroup;
    const isCritical = !!g.get("isCritical")?.value;
    if (!isCritical) return null;

    const anySelected = keys.some((k) => !!g.get(k)?.value);
    return anySelected ? null : { anySelected: true };
  };
}
